import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import GoogleIcon from '../google-icon';

function SearchFormSitecore({
    keyphraseHandler,
    searchQuery,
    handleSubmit,
    onClickClear,
    onFocus = () => {}
}) {
    const [localValue, setLocalValue] = useState(searchQuery);

    // Debounce the onChange callback
    useEffect(() => {
        const timer = setTimeout(() => {
            if (localValue !== searchQuery) {
                keyphraseHandler({ target: { value: localValue } });
            }
        }, 100); // 300ms delay

        return () => clearTimeout(timer);
    }, [localValue, searchQuery, keyphraseHandler]);

    const handleInputChange = e => {
        setLocalValue(e.target.value);
    };

    const onClear = () => {
        setLocalValue('');
        onClickClear();
    };

    // Explicitly listen to key events to ensure cross-browser compatibility.
    // Some browser executes the default form behavior insteaf of calling handleSubmit as expected.
    const handleKeyDown = e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <div className="sitecore-search-bar-container">
            <form className="sitecore-search-bar-search-form" onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="query"
                    className="sitecore-search"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    value={localValue}
                    autoComplete="off"
                    placeholder="Search"
                    onFocus={onFocus}
                />
                <GoogleIcon className="search-form-icon" icon="search" />
                {
                    searchQuery !== '' && (
                        <button className="sitecore-search-bar-form-clear" type="button" onClick={onClear}>
                            <GoogleIcon className="search-form-clear-icon" icon="close" />
                        </button>
                    )
                }
            </form>
        </div>
    );
}

SearchFormSitecore.propTypes = {
    keyphraseHandler: PropTypes.func.isRequired,
    searchQuery: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onClickClear: PropTypes.func.isRequired,
    onFocus: PropTypes.func
};

export default SearchFormSitecore;
